import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'link-button',
  templateUrl: './link-button.component.html',
  styleUrls: ['./link-button.component.scss']
})
export class LinkButtonComponent implements OnInit {

  @Input() name: string;
  @Input() iconUrl: string;
  @Input() class: string;
  @Input() smallRightMargin: boolean;
  @Output() onClick: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

}
